import { Component, type ReactNode } from 'react';

export interface ViewerErrorBoundaryProps {
  children?: ReactNode;
}

interface ViewerErrorBoundaryState {
  hasError: boolean;
}

export class ViewerErrorBoundary extends Component<ViewerErrorBoundaryProps, ViewerErrorBoundaryState> {
  constructor(props: ViewerErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ViewerErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    console.error('Showroom viewer failed to render', error);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="viewer-fallback" role="alert">
          <p>3D 뷰어를 표시할 수 없습니다.</p>
          <p>브라우저를 새로 고치거나 WebGL을 지원하는 브라우저에서 다시 시도해 주세요.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
